import CacheBackedStore from './CacheBackedStore';

/**
 * On web, we just proxy the CacheBackedStore. Perhaps eventually we would want to
 * implement a *real* file-backed store on Web for performance reasons.
 */
export const FileBackedStore = CacheBackedStore;
